export default "__VITE_ASSET__G2w0Fpcp__"